import React, { ReactNode } from 'react';
import { Menu as MenuPrimitive } from '@headlessui/react';

type Props = {
  children: ReactNode;
};

export default function Menu({ children }: Props) {
  return (
    <MenuPrimitive as="div" className="relative inline-block text-left">
      {children}
    </MenuPrimitive>
  );
}
